<table
  mat-table
  matSort
  [dataSource]="dataSource"
  [attr.aria-label]="ariaLabel"
  class="shared-table"
>
  @for (column of columns; track column.key) {
    <ng-container [matColumnDef]="column.key">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [disabled]="!column.sortable"
      >
        {{ column.header }}
      </th>
      <td mat-cell *matCellDef="let row">
        @if (cellTemplates[column.key]; as cellTemplate) {
          <ng-container
            *ngTemplateOutlet="cellTemplate; context: { $implicit: row }"
          ></ng-container>
        } @else {
          {{ row[column.key] }}
        }
      </td>
    </ng-container>
  }

  <ng-container [matColumnDef]="actionsColumn">
    <th mat-header-cell *matHeaderCellDef aria-label="Actions"></th>
    <td
      mat-cell
      *matCellDef="let row"
      class="shared-table__actions"
      (click)="$event.stopPropagation()"
    >
      <ng-container
        *ngTemplateOutlet="rowActions ?? null; context: { $implicit: row }"
      ></ng-container>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
    class="shared-table__row"
    [class.shared-table__row--clickable]="clickable"
    [attr.tabindex]="clickable ? 0 : null"
    (click)="clickable && rowClick.emit(row)"
    (keydown)="onRowKeydown($event, row)"
  ></tr>
  <tr class="mat-mdc-row" *matNoDataRow>
    <td class="shared-table__empty" [attr.colspan]="displayedColumns.length">
      {{ emptyMessage }}
    </td>
  </tr>
</table>
@if (pagination && data.length > pageSize) {
  <mat-paginator
    [pageSize]="pageSize"
    [hidePageSize]="true"
    [showFirstLastButtons]="true"
    aria-label="Table pagination"
  ></mat-paginator>
}
